type LegalLinksType = {
  privacyPolicy: string,
  ica: string
}

export const getLegalLinksForCountry = (currentSignUpCountry: { [k: string]: boolean }) : LegalLinksType => {
  if (currentSignUpCountry.isJP) {
    return {
      ica: 'https://help.doordash.com/dashers/s/ica-jp',
      privacyPolicy: 'https://help.doordash.com/dashers/s/privacy-policy-jp',
    }
  }
  else if (currentSignUpCountry.isCA) {
    return {
      ica: 'https://help.doordash.com/dashers/s/ica-ca',
      privacyPolicy: 'https://help.doordash.com/dashers/s/privacy-policy-ca',
    }
  }
  else if (currentSignUpCountry.isAU) {
    return {
      ica: 'https://help.doordash.com/dashers/s/ica-au',
      privacyPolicy: 'https://help.doordash.com/dashers/s/privacy-policy-au',
    }
  }

  // DE links don't exist yet it seems
  return {
    ica: 'https://help.doordash.com/dashers/s/ica-us',
    privacyPolicy: 'https://help.doordash.com/dashers/s/privacy-policy-us'
  }
}
